import { type ReactElement, type ReactNode } from 'react'
import cn from 'classnames'

interface ButtonProps {
  clickFunction: (event: React.MouseEvent<HTMLButtonElement>) => void
  icon: ReactNode
  text: string
}

function EndRecurringPaymentButton ({ clickFunction, icon, text }: ButtonProps): ReactElement {
  return (
    <button
      onClick={clickFunction}
      type="button"
      className={cn('hover:bg-red-100', 'disabled:bg-gray-200', 'flex items-center justify-center py-2 px-4 shadow text-red-500 bg-white border border-red-500 rounded')}
    >
      <div className={cn('text-red-500', 'mr-2')}>{icon}</div>
      {text}
    </button>
  )
}

export default EndRecurringPaymentButton
